<script lang="ts" setup>
  import { useRoute } from 'vue-router'
  import { ArDataType, useAR } from '@/store/Pinia/useAR.store'
  import Contact from '@/components/Molecules/Contact.vue'
  import Breadcrumb from '@/components/Molecules/Breadcrumbs.vue'
  import arController from '@/infra/BirdId/controllers/ar.controller'
  import CardContainerWithHoverShadow from './components/Atoms/CardContainerWithHoverShadow.vue'
  import { onBeforeMount } from 'vue'

  const pathList = {
    'Instalar Certificado': 'guia-de-instalacao-de-certificado-digital',
  }

  onBeforeMount(async () => {
    const route = useRoute()
    const arStore = useAR()
    const arSubDomain =
      route.params.arsubdomain || arStore.arData.subdomain || 'arsoluti'

    const arDataClean = {
      subdomain: '',
      nomeAr: '',
      logo: '',
      foneAR: '',
      siteAR: '',
      emissorLink: '',
    }

    if (arSubDomain === arStore.arData.subdomain) {
      return
    }

    arStore.setArData(arDataClean)
    await arController
      .getArData(`${arSubDomain}`)
      .then(({ data: dataAr }) => {
        const modalSave = { ...arDataClean, ...dataAr, subdomain: arSubDomain }
        arStore.setArData(modalSave as ArDataType)
      })
      .catch(() => {
        arStore.setArData(arDataClean as ArDataType)
      })
  })
</script>

<template>
  <div class="container">
    <section class="breadcrumb-wrapper pt-3">
      <breadcrumb :path-list="pathList" />
    </section>

    <section class="page-title-wrapper text-start pt-4">
      <h2 class="fw-600">Guia de instalação de Certificado Digital</h2>
    </section>

    <section class="pt-5">
      <p class="fs-6 text-start">
        Aqui, disponibilizamos todos os guias de instalação para os diferentes
        tipos de certificados que você adquiriu. Escolha o seu tipo de
        certificado e simplifique o processo de instalação.
      </p>
    </section>

    <section class="options-wrapper">
      <card-container-with-hover-shadow>
        <router-link
          :to="{ name: 'installationToken' }"
          class="d-flex align-items-center flex-column pt-5 pb-2"
        >
          <img
            width="124"
            height="110"
            src="./assets/smartcard.svg"
            alt="smartcard"
          />
          <span class="mt-4"
            >A3 com instalação em <strong>Token ou smartcard</strong></span
          >
        </router-link>
      </card-container-with-hover-shadow>

      <card-container-with-hover-shadow>
        <router-link
          to="/issue/plugin"
          class="d-flex align-items-center flex-column pt-5 pb-2"
        >
          <img
            width="128"
            height="110"
            src="./assets/desktop.svg"
            alt="desktop"
          />
          <span class="mt-4"
            >A1 com instalação direta no <strong>Computador</strong></span
          >
        </router-link>
      </card-container-with-hover-shadow>

      <card-container-with-hover-shadow>
        <router-link
          to="/installation-guide-birdid"
          class="d-flex align-items-center flex-column pt-5 pb-2"
        >
          <img width="73" height="110" src="./assets/birdid.svg" alt="birdid" />
          <span class="mt-4"
            >Certificado em nuvem <strong>Bird ID</strong></span
          >
        </router-link>
      </card-container-with-hover-shadow>

      <card-container-with-hover-shadow>
        <router-link
          to="/ssl-certificate/installation-guide-ssl"
          class="d-flex align-items-center flex-column pt-5 pb-2"
        >
          <img width="80" height="110" src="./assets/lock.svg" alt="lock" />
          <span class="mt-4"
            >Certificados <strong>Financeiros e SSL</strong></span
          >
        </router-link>
      </card-container-with-hover-shadow>
    </section>

    <section class="py-3">
      <contact />
    </section>
  </div>
</template>

<style scoped>
  .options-wrapper {
    display: flex;
    gap: 1rem;
  }

  @media screen and (max-width: 768px) {
    .options-wrapper {
      flex-wrap: wrap;
    }
  }
</style>
